import type {
  Automation,
  AutomationActionTypes,
  ListedAutomationsListViewPage,
} from '@payaca/types/automationTypes';
import type { FetchedEntity } from '@payaca/types/storeTypes';
export interface State {
  automations: {
    [key: number]: FetchedEntity<Automation<AutomationActionTypes>>;
  };

  isCreatingAutomation: boolean;

  isGettingListedAutomationsPage: boolean;
  listedAutomationsPage: ListedAutomationsListViewPage | null;

  isPerformingAutomationAction: boolean;

  isArchivingAutomations: boolean;
}

export enum ActionType {
  REQUEST_GET_LISTED_AUTOMATIONS_PAGE = 'automations.requestGetListedAutomationsPage',
  GET_LISTED_AUTOMATIONS_PAGE_SUCCESS = 'automations.getListedAutomationsPageSuccess',
  GET_LISTED_AUTOMATIONS_PAGE_FAILURE = 'automations.getListedAutomationsPageFailure',

  REQUEST_GET_AUTOMATION = 'automations.requestGetAutomation',
  GET_AUTOMATION_SUCCESS = 'automations.getAutomationSuccess',
  GET_AUTOMATION_FAILURE = 'automations.getAutomationFailure',

  REQUEST_CREATE_AUTOMATION = 'automations.requestCreateAutomation',
  CREATE_AUTOMATION_SUCCESS = 'automations.createAutomationSuccess',
  CREATE_AUTOMATION_FAILURE = 'automations.createAutomationFailure',

  REQUEST_UPDATE_AUTOMATION = 'automations.requestUpdateAutomation',
  UPDATE_AUTOMATION_SUCCESS = 'automations.updateAutomationSuccess',
  UPDATE_AUTOMATION_FAILURE = 'automations.updateAutomationFailure',

  REQUEST_ARCHIVE_AUTOMATIONS = 'automations.requestArchiveAutomations',
  ARCHIVE_AUTOMATIONS_SUCCESS = 'automations.archiveAutomationsSuccess',
  ARCHIVE_AUTOMATIONS_FAILURE = 'automations.archiveAutomationsFailure',

  CLEAR_AUTOMATIONS = 'automations.clearAutomations',
}

export interface SagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp: boolean;
}
